var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"kk-aux-menu",attrs:{"href":_vm.href,"target":"_blank"}},[_c('auxiliary-menu-button',{attrs:{"title":_vm.title,"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }